

export interface TriggerValueStateChangeAction<T>
{
    type: "TRIGGER_VALUE_STATE_CHANGE";
    value: T;
    statePath: string;
}

export interface TriggerObjectStateChangeAction<T>
{
    type: "TRIGGER_OBJECT_STATE_CHANGE";
    value: T;
    statePath: string;
}

export function triggerValueStateChange<T>(value: T, statePath: string): TriggerValueStateChangeAction<T>
{
    return {
        type: "TRIGGER_VALUE_STATE_CHANGE",
        value,
        statePath,
    };
}

export function triggerObjectStateChange<T>(value: T, statePath: string): TriggerObjectStateChangeAction<T>
{
    return {
        type: "TRIGGER_OBJECT_STATE_CHANGE",
        value,
        statePath,
    };
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/state-triggerer/src/models/Actions.ts